module.exports = __webpack_public_path__ + "img/logo-dark.a4200f0d.png";